import { render, staticRenderFns } from "./instruction.vue?vue&type=template&id=d18ec602&scoped=true&"
import script from "./instruction.vue?vue&type=script&lang=js&"
export * from "./instruction.vue?vue&type=script&lang=js&"
import style0 from "./instruction.vue?vue&type=style&index=0&id=d18ec602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18ec602",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDialog,VRow})
